import React, { useEffect, useState } from "react";
import { useIntl } from "react-intl";
import { useUserBranches } from "../../hooks/accessControl";
import { Tag } from "antd";

const UserBranches = (props) => {
  const { record } = props;
  const intl = useIntl();
  const userBranches = useUserBranches();
  const [branchesNames, setBranchesNames] = useState([]);

  useEffect(() => {
    let branches = [];
    if (record.roles) {
      record.roles.forEach((role, i) => {
        const items = (userBranches || []).filter(
          (branch) => branch.id === role.branch_id
        );
        if (items && items.length > 0) {
          branches.push(items[0].name);
        }
      });
    }

    setBranchesNames(branches);
  }, [record.roles, userBranches]);

  return (
    <div>
      {branchesNames.length > 0 ? (
        branchesNames.map((name) => <Tag key={name}>{name}</Tag>)
      ) : (
        <Tag>
          {intl.formatMessage({
            id: "app.users.allBranches",
          })}
        </Tag>
      )}
    </div>
  );
};

export default UserBranches;
